import { useEffect } from "react"

const useHideDisabledColumns = (styleId = "hide-disabled-columns-style") => {
  useEffect(() => {
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style")
      style.id = styleId
      style.textContent = `
        .MuiDataGrid-columnsManagementRow .Mui-disabled {
          display: none !important;
        }
        .MuiDataGrid-columnsManagement .MuiFormControlLabel-root.Mui-disabled {
          display: none !important;
        }
      `
      document.head.appendChild(style)
    }
    return () => {
      const existingStyle = document.getElementById(styleId)
      if (existingStyle) existingStyle.remove()
    }
  }, [styleId])
}

export default useHideDisabledColumns
